var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Clock")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CLF--Bexio",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "09_Bexio",
    transform: "translate(-694.000000, -310.000000)",
    fill: "#253858",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(694.000000, 310.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5,2 C30.1649831,2 38,9.83501688 38,19.5 C38,29.1649831 30.1649831,37 20.5,37 C10.8350169,37 3,29.1649831 3,19.5 C3,9.83501688 10.8350169,2 20.5,2 Z M20.5,5 C12.4918711,5 6,11.4918711 6,19.5 C6,27.5081289 12.4918711,34 20.5,34 C28.5081289,34 35,27.5081289 35,19.5 C35,11.4918711 28.5081289,5 20.5,5 Z M20.5,9 C21.2796961,9 21.9204487,9.59488808 21.9931334,10.35554 L22,10.5 L22,18 L29.5,18 C30.3284271,18 31,18.6715729 31,19.5 C31,20.2796961 30.4051119,20.9204487 29.64446,20.9931334 L29.5,21 L20.5,21 C19.7203039,21 19.0795513,20.4051119 19.0068666,19.64446 L19,19.5 L19,10.5 C19,9.67157288 19.6715729,9 20.5,9 Z",
    id: "Stroke"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.d328da5a.svg";
export { ForwardRef as ReactComponent };